import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import axiosInstance from './services/axiosInstance';

const initialForm = {
  codice: '',
  codiceMymemory: '',
  descrizione: '',
  attiva: true,
};

const GestioneLingue = () => {
  const [lingue, setLingue] = useState([]);
  const [caricamento, setCaricamento] = useState(true);
  const [form, setForm] = useState(initialForm);
  const [invioInCorso, setInvioInCorso] = useState(false);

  const carica = () => {
    setCaricamento(true);
    axiosInstance.get('/lingue/all')
      .then((res) => setLingue(Array.isArray(res.data) ? res.data : []))
      .catch(() => toast.error('Impossibile caricare le lingue'))
      .finally(() => setCaricamento(false));
  };

  useEffect(() => {
    carica();
  }, []);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm((prev) => ({ ...prev, [name]: type === 'checkbox' ? checked : value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!form.codice.trim() || !form.codiceMymemory.trim()) {
      toast.warn('Codice e codice MyMemory sono obbligatori');
      return;
    }
    setInvioInCorso(true);
    axiosInstance.post('/lingue', {
      codice: form.codice.trim().toLowerCase(),
      codiceMymemory: form.codiceMymemory.trim(),
      descrizione: form.descrizione.trim(),
      attiva: form.attiva,
    })
      .then(() => {
        toast.success('Lingua creata');
        setForm(initialForm);
        carica();
      })
      .catch((err) => {
        const msg = err?.response?.data || 'Errore durante la creazione';
        toast.error(typeof msg === 'string' ? msg : 'Errore durante la creazione');
      })
      .finally(() => setInvioInCorso(false));
  };

  return (
    <div style={{ maxWidth: 900, margin: '20px auto', padding: 20 }}>
      <h2>Gestione lingue</h2>

      <section style={{ marginBottom: 30 }}>
        <h3>Nuova lingua</h3>
        <form onSubmit={handleSubmit}>
          <label>
            Codice ISO (es. <em>de</em>):
            <input
              type="text"
              name="codice"
              value={form.codice}
              onChange={handleChange}
              maxLength={5}
              required
            />
          </label>
          <label>
            Codice MyMemory (es. <em>de-DE</em>):
            <input
              type="text"
              name="codiceMymemory"
              value={form.codiceMymemory}
              onChange={handleChange}
              maxLength={10}
              required
            />
          </label>
          <label>
            Descrizione (es. <em>Tedesco</em>):
            <input
              type="text"
              name="descrizione"
              value={form.descrizione}
              onChange={handleChange}
            />
          </label>
          <label style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <input
              type="checkbox"
              name="attiva"
              checked={form.attiva}
              onChange={handleChange}
              style={{ width: 'auto' }}
            />
            Attiva
          </label>
          <button type="submit" disabled={invioInCorso}>
            {invioInCorso ? 'Salvataggio...' : 'Crea lingua'}
          </button>
        </form>
      </section>

      <section>
        <h3>Lingue esistenti</h3>
        {caricamento ? (
          <p>Caricamento...</p>
        ) : lingue.length === 0 ? (
          <p>Nessuna lingua configurata.</p>
        ) : (
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr>
                <th style={{ textAlign: 'left', padding: 8, borderBottom: '1px solid #ccc' }}>Codice</th>
                <th style={{ textAlign: 'left', padding: 8, borderBottom: '1px solid #ccc' }}>Codice MyMemory</th>
                <th style={{ textAlign: 'left', padding: 8, borderBottom: '1px solid #ccc' }}>Descrizione</th>
                <th style={{ textAlign: 'left', padding: 8, borderBottom: '1px solid #ccc' }}>Attiva</th>
              </tr>
            </thead>
            <tbody>
              {lingue.map((l) => (
                <tr key={l.idLingua || l.codice}>
                  <td style={{ padding: 8, borderBottom: '1px solid #eee' }}>{l.codice}</td>
                  <td style={{ padding: 8, borderBottom: '1px solid #eee' }}>{l.codiceMymemory}</td>
                  <td style={{ padding: 8, borderBottom: '1px solid #eee' }}>{l.descrizione}</td>
                  <td style={{ padding: 8, borderBottom: '1px solid #eee' }}>{l.attiva ? '✔' : '✖'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </section>
    </div>
  );
};

export default GestioneLingue;
